import cs from "classnames"
export const BaseIcon= ({ children, className }) => {
    return (
        <span className={cs('inline-flex items-center justify-center ', className)}>{children}</span>
    );
};

BaseIcon.defaultProps = {
    size: 'w-12 h-12',
};